export default "__VITE_ASSET__BB9e4DHv__"